<template>
  <div class="other-bg" :style="{ backgroundImage: 'url(' + BG + ')' }">
    <loading :active.sync="isLoading"></loading>
    <div class="container-cm">
      <div class="sidemap">
        <a href="#U" title="中央內容區塊" id="AU" accesskey="U" name="U">:::</a>
        <a href="/Sitemap" title="網站導覽">網站導覽</a>
      </div>
    </div>
    <div class="container-cm">
      <h1 class="logo">
        <a href="/" title="農科院農業課程報名及查詢系統:回首頁">
          <img
            src="../assets/images/LOGO.png"
            alt="農科院農業課程報名及查詢系統:回首頁"
          />
        </a>
      </h1>
      <main class="training-content">
        <div class="registration-title">
          <h2 :class="!ms_ie ? 'training-h2' : 'training-h2-ie'">課程報名</h2>
          <span>*項目皆為必填</span>
        </div>
        <div class="table-line"></div>
        <div class="training-detail-container">
          <div
            class="training-detail-content"
            v-if="!error && !isLimit && !isStart && !isOver"
          >
            <a href="#C" title="中央內容區塊" id="AC" accesskey="C" name="C"
              >:::</a
            >
            <div class="list" v-if="trainingDetail.Number">
              <div class="input-block">
                <span class="title">課程代碼</span>
                <span class="content">{{ trainingDetail.Number }}</span>
              </div>
            </div>
            <ValidationObserver ref="form">
              <!-- 姓名 -->
              <ValidationProvider
                class="list"
                rules="required"
                name="姓名"
                v-slot="{ errors }"
                data-Required="true"
              >
                <div class="input-block">
                  <label class="title" for="Name">姓名*</label>
                  <input
                    class="content"
                    :class="{ 'is-invalid': errors[0] }"
                    id="Name"
                    type="text"
                    v-model="registerData.Name"
                    title="請在此輸入您的大名"
                    placeholder="請填寫報名大名"
                  />
                </div>
                <span class="text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
              <!-- 生日 -->
              <ValidationProvider
                class="list"
                rules="required"
                name="生日"
                v-slot="{ errors }"
                data-Required="true"
              >
                <div class="input-block">
                  <label class="title" for="Birthday">生日(民國)*</label>
                  <input
                    class="content"
                    :class="{
                      'is-invalid': errors[0] && !tmpRegisterData.Birthday,
                    }"
                    id="Birthday"
                    type="text"
                    name="Birthday"
                    v-model="tmpRegisterData.Birthday"
                    title="請在此輸入您的生日"
                    placeholder="請填寫生日"
                  />
                </div>
                <span class="text-danger" v-if="!tmpRegisterData.Birthday">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
              <!-- 信箱 -->
              <ValidationProvider
                class="list"
                rules="required|email"
                v-slot="{ errors }"
                data-Required="true"
              >
                <div class="input-block">
                  <label class="title" for="Email">E-mail*</label>
                  <input
                    type="text"
                    id="Email"
                    v-model="registerData.ContactBox"
                    placeholder="請填寫常用E-mail"
                    title="請在此輸入您的E-mail"
                    class="content"
                    :class="{ 'is-invalid': errors[0] }"
                  />
                </div>
                <span class="text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
              <!-- 公司名稱 -->
              <ValidationProvider
                class="list"
                rules="required"
                name="公司名稱"
                v-slot="{ errors }"
                data-Required="true"
              >
                <div class="input-block">
                  <label class="title" for="Company">公司名稱*</label>
                  <input
                    class="content"
                    :class="{ 'is-invalid': errors[0] }"
                    id="Company"
                    type="text"
                    v-model="registerData.Office"
                    title="請在此輸入您的公司名稱"
                    placeholder="請在此輸入您的公司名稱"
                  />
                </div>
                <span class="text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
              <!-- 連絡電話 -->
              <ValidationProvider
                class="list"
                rules="required"
                name="手機號碼"
                v-slot="{ errors }"
                data-Required="true"
              >
                <div class="input-block">
                  <label class="title" for="Phone">手機號碼*</label>
                  <input
                    class="content"
                    :class="{ 'is-invalid': errors[0] }"
                    id="Phone"
                    type="text"
                    v-model="registerData.Mobile"
                    title="請在此輸入您的手機號碼"
                    placeholder="請填寫可聯繫到的手機號碼"
                  />
                </div>
                <span class="text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
              <!-- 飲食習慣 -->
              <!-- <ValidationProvider
                class="list"
                rules="required"
                name="飲食習慣"
                v-slot="{ errors }"
                data-Required="true"
              >
                <div class="input-block">
                  <label class="title" for="EatingHabits">飲食習慣*</label>
                  <input
                    class="content"
                    :class="{ 'is-invalid': errors[0] }"
                    id="EatingHabits"
                    type="text"
                    v-model="registerData.EatingHabits"
                    title="請在此輸入您的飲食習慣"
                    placeholder="請填寫您的飲食習慣(葷、素、其他)"
                  />
                </div>
                <span class="text-danger">{{ errors[0] }}</span>
              </ValidationProvider> -->

              <ValidationProvider
                class="list"
                rules="required"
                name="通訊地址"
                v-slot="{ errors }"
                data-Required="true"
              >
                <div class="input-block">
                  <label class="title" for="Address">通訊地址*</label>
                  <input
                    class="content"
                    :class="{ 'is-invalid': errors[0] }"
                    id="Address"
                    type="text"
                    v-model="registerData.Address"
                    title="請在此輸入您的通訊地址"
                    placeholder="請填寫您的通訊地址"
                  />
                </div>
                <span class="text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
              <template v-for="item in postOptions">
                <ValidationProvider
                  class="list"
                  rules="required"
                  :name="item.DisplayName"
                  v-slot="{ errors }"
                  v-if="item.Required"
                  :key="item.Id"
                  :data-Required="item.Required"
                >
                  <div class="input-block" v-if="item.Type === 1">
                    <label class="title" :for="item.ColumnName"
                      >{{ item.DisplayName }}*</label
                    >
                    <input
                      class="content"
                      :class="{ 'is-invalid': errors[0] }"
                      :id="item.ColumnName"
                      type="text"
                      v-model="item.Info"
                      :title="`請在此輸入${item.DisplayName}`"
                      :placeholder="`請在此輸入${item.DisplayName}`"
                    />
                  </div>
                  <!-- text -->
                  <span class="text-danger" v-if="item.Type === 1">{{
                    errors[0]
                  }}</span>
                  <!-- textarea -->
                  <div class="input-block" v-if="item.Type === 2">
                    <label class="title" :for="item.ColumnName"
                      >{{ item.DisplayName }}*</label
                    >
                    <textarea
                      class="content"
                      :class="{ 'is-invalid': errors[0] }"
                      :id="item.ColumnName"
                      v-model="item.Info"
                      :title="`請在此輸入${item.DisplayName}`"
                      :placeholder="`請在此輸入${item.DisplayName}`"
                    ></textarea>
                  </div>
                  <span class="text-danger" v-if="item.Type === 2">{{
                    errors[0]
                  }}</span>
                  <!-- checkbox -->
                  <div class="input-block" v-if="item.Type === 3">
                    <label class="title" :for="item.ColumnName"
                      >{{ item.DisplayName }}*</label
                    >
                    <input
                      class="content checkbox"
                      :class="{ 'is-invalid': errors[0] }"
                      :id="item.ColumnName"
                      type="checkbox"
                      v-model="item.Info"
                    />
                  </div>
                  <!-- <span class="text-danger">{{ errors[0] }}</span> -->
                </ValidationProvider>
                <template v-else>
                  <div
                    class="list"
                    :name="item.DisplayName"
                    :key="item.Id"
                    v-if="item.Type === 1"
                    :data-Required="item.Required"
                  >
                    <div class="input-block">
                      <label class="title" :for="item.ColumnName">{{
                        item.DisplayName
                      }}</label>
                      <input
                        class="content"
                        :id="item.ColumnName"
                        type="text"
                        v-model="item.Info"
                        :title="`請在此輸入${item.DisplayName}`"
                        :placeholder="`請在此輸入${item.DisplayName}`"
                      />
                    </div>
                  </div>
                  <div
                    class="list"
                    :name="item.DisplayName"
                    :key="item.Id"
                    v-if="item.Type === 2"
                    :data-Required="item.Required"
                  >
                    <div class="input-block">
                      <label class="title" :for="item.ColumnName">{{
                        item.DisplayName
                      }}</label>
                      <textarea
                        class="content"
                        :id="item.ColumnName"
                        v-model="item.Info"
                        :title="`請在此輸入${item.DisplayName}`"
                        :placeholder="`請在此輸入${item.DisplayName}`"
                      ></textarea>
                    </div>
                  </div>
                  <div
                    class="list"
                    :name="item.DisplayName"
                    :key="item.Id"
                    v-if="item.Type === 3"
                    :data-Required="item.Required"
                  >
                    <div class="input-block">
                      <label class="title" :for="item.ColumnName">{{
                        item.DisplayName
                      }}</label>
                      <input
                        class="content checkbox"
                        :id="item.ColumnName"
                        type="checkbox"
                        v-model="item.Info"
                      />
                    </div>
                  </div>
                </template>
              </template>
              <div class="list">
                <div class="input-block">
                  <label class="title" for="inputCode">請輸入驗證碼</label>
                  <div class="inputbox">
                    <input
                      type="text"
                      id="inputCode"
                      class="content"
                      v-model="inputCode"
                      title="請在此輸入驗證碼"
                    />
                  </div>
                  <div class="inputbox">
                    <div
                      class="code"
                      id="checkCode"
                      @click.prevent="createCodelogin"
                      :title="code"
                    >
                      {{ code }}
                    </div>
                    <a
                      id="refrash"
                      href="#"
                      class="codeBtn"
                      @click.prevent="createCodelogin"
                      role="button"
                    >
                      更新驗證碼
                    </a>
                  </div>
                </div>
              </div>
              <div class="btn-box">
                <a
                  class="btn light-green"
                  href="#"
                  title="送出資料並開啟個資同意視窗"
                  @click.prevent="openPopup"
                  role="button"
                  >送出</a
                >
                <a
                  class="btn reset"
                  href="#"
                  title="重設填寫內容"
                  @click.prevent="reset"
                  role="button"
                  >重設</a
                >
                <a class="btn cancel" href="/Course/Index" title="取消:回列表頁"
                  >取消</a
                >
              </div>
            </ValidationObserver>
          </div>
          <div class="training-detail-content error" v-if="!error && isLimit">
            <a href="#C" title="中央內容區塊" id="AC" accesskey="C" name="C"
              >:::</a
            >
            <div class="number" v-if="!error"></div>
            <p v-if="!error">很抱歉，本課程已達上限人數</p>
            <!-- <p v-if="error">您點擊進來的連結可能發生故障，或該頁面已被移除，</p> -->
            您可回<a href="/" title="農科院農業課程報名及查詢系統:回首頁"
              >首頁</a
            >，繼續瀏覽其他頁面，謝謝!
          </div>
          <div class="training-detail-content error" v-if="!error && isStart">
            <a href="#C" title="中央內容區塊" id="AC" accesskey="C" name="C"
              >:::</a
            >
            <div class="number" v-if="!error"></div>
            <p v-if="!error">很抱歉，本課程尚未開始報名</p>
            <!-- <p v-if="error">您點擊進來的連結可能發生故障，或該頁面已被移除，</p> -->
            您可回<a href="/" title="農科院農業課程報名及查詢系統:回首頁"
              >首頁</a
            >，繼續瀏覽其他頁面，謝謝!
          </div>
          <div class="training-detail-content error" v-if="!error && isOver">
            <a href="#C" title="中央內容區塊" id="AC" accesskey="C" name="C"
              >:::</a
            >
            <div class="number" v-if="!error"></div>
            <p v-if="!error">很抱歉，本課程已超過報名時間</p>
            <!-- <p v-if="error">您點擊進來的連結可能發生故障，或該頁面已被移除，</p> -->
            您可回<a href="/" title="農科院農業課程報名及查詢系統:回首頁"
              >首頁</a
            >，繼續瀏覽其他頁面，謝謝!
          </div>
          <div class="training-detail-content error" v-if="error">
            <a href="#C" title="中央內容區塊" id="AC" accesskey="C" name="C"
              >:::</a
            >
            <div class="number" v-if="error">404</div>
            <p v-if="error">很抱歉，您要訪問的頁面不存在!</p>
            <p v-if="error">您點擊進來的連結可能發生故障，或該頁面已被移除，</p>
            您可回<a href="/" title="農科院農業課程報名及查詢系統:回首頁"
              >首頁</a
            >，繼續瀏覽其他頁面，謝謝!
          </div>
        </div>
      </main>
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
// 載入驗證套件 VeeValidate
import {
  ValidationProvider,
  ValidationObserver,
  localize,
  extend,
} from 'vee-validate';
// 載入所有規則
import * as rules from 'vee-validate/dist/rules';
// 載入中文化
import tw from 'vee-validate/dist/locale/zh_TW.json';
import Api from '@/assets/api/course';
import Footer from '@/components/Footer.vue';
import $ from 'jquery';
import BG from '../assets/images/content_BG01.jpg';
import 'jquery-ui/ui/widgets/datepicker';
import 'jquery-ui/ui/i18n/datepicker-zh-TW';
import 'jquery-ui/themes/base/all.css';

export default {
  name: 'trainingregistration',
  components: {
    Footer,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      BG,
      trainingDetail: {},
      registerData: {
        Name: '',
        ContactBox: '',
        Mobile: '',
        Office: '',
        Birthday: '',
        CourseId: 0,
        // EatingHabits: 'test',
        Address: '',
      },
      tmpRegisterData: {
        Name: '',
        Birthday: '',
        Address: '',
      },
      postRegisterData: '',
      options: [],
      postOptions: [],
      isChecked: false,
      // eslint-disable-next-line global-require
      scarecrowImg: require('../assets/images/scarecrow.png'),
      alertSet: {
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: '確定',
        confirmButtonAriaLabel: '確定',
        cancelButtonText: '取消',
        cancelButtonAriaLabel: '取消',
        closeButtonAriaLabel: '關閉視窗',
        reverseButtons: true,
        confirmButtonColor: '#4dba95',
        cancelButtonColor: '#bfbfbf',
        width: '1200px',
        html: '',
        focusConfirm: false,
      },
      planOption: ['方案一', '方案二'],
      isLoading: false,
      CourseId: 0,
      error: false,
      inputCheck: [],
      isPassed: false,
      code: '',
      checkCode: '',
      inputCode: '',
      ms_ie: false,
      isLimit: false, //  判斷到人數上限了沒
      isStart: false, // 判斷開始了沒
      isOver: false, // 判斷超過時間了沒
    };
  },
  methods: {
    openPopup() {
      const vm = this;
      vm.inputCheck = [];
      vm.registerData.Birthday = vm.tmpRegisterData.Birthday;
      // const tmpMobile = vm.registerData.mobile.replaceAll('-', '');
      // const mobileRule = /^[0]{1}[9]{1}[0-9]{8}$/;
      // vm.$refs.form.validate().then((res) => {
      // if (res) {
      $(':input').each(function () {
        if ($(this).data === true) {
          vm.inputCheck.push($(this).val());
        }
      });
      if (!vm.inputCheck.includes('')) {
        vm.isPassed = true;
      } else {
        vm.isPassed = false;
      }
      if (vm.inputCode !== vm.code) {
        vm.$swal({
          icon: 'warning',
          text: '請確認驗證碼',
          confirmButtonColor: '#4dba95',
          confirmButtonText: '確定',
          confirmButtonAriaLabel: '確定',
          focusConfirm: true,
        });
      } else if (!vm.inputCode) {
        vm.$swal({
          icon: 'warning',
          text: '請輸入驗證碼',
          confirmButtonColor: '#4dba95',
          confirmButtonText: '確定',
          confirmButtonAriaLabel: '確定',
          focusConfirm: true,
        });
      } else if (vm.isPassed && vm.IsEmail(vm.registerData.ContactBox)) {
        let tmpTitle = '';
        if (vm.ms_ie) {
          tmpTitle = '<h2 class="training-h2-ie text-flex">';
        } else {
          tmpTitle = '<h2 class="training-h2 text-flex">';
        }
        const tmpHtml = `${tmpTitle}
          <img
            src="${vm.scarecrowImg}"
            alt="稻草人圖案"
          />個人資料聲明同意書
        </h2>
        <p>
          一、為提供貴單位未來相關服務權益，本院必須蒐集、處理及利用您所提供之個人資料，以利進行資料
          傳遞、處理與分析。<br />
          二、本院得依循個人資料保護法及相關法令之規定，於個人資料提供之範圍與目的內使用該等個人資料，並予以保密及妥善保管。
        </p>
        <h3 class="training-h3">
          [聲明：請報名人親自報名，如未經他人同意擅自使用他人個人資料報名，將有相關民刑事責任。]
        </h3>
        <a href="/Privacy" title="前往完整個人資料提供同意書:另開視窗" target="_blank" rel="noreferrer noopener">完整個人資料提供同意書</a>
        <div class="pop-check">
          ※<input type="checkbox" v-model="isChecked" id="popCheck" /><label
            for="popCheck"
            >我已詳閱個人資料同意書並且同意遵守所有規定</label
          >
        </div>`;
        vm.alertSet.html = tmpHtml;
        vm.$swal(vm.alertSet).then((result) => {
          if (result.isConfirmed) {
            if ($('#popCheck').prop('checked')) {
              vm.submit();
            } else {
              vm.noCheckDialog();
            }
          }
        });
      } else {
        vm.$swal({
          icon: 'warning',
          text: '請再次確認填寫內容',
          confirmButtonColor: '#4dba95',
          confirmButtonText: '確定',
          confirmButtonAriaLabel: '確定',
          focusConfirm: true,
        });
      }
    },
    noCheckDialog() {
      const vm = this;
      vm.$swal({
        icon: 'warning',
        text: '請勾選我已詳閱個人資料同意書並且同意遵守所有規定',
        confirmButtonColor: '#4dba95',
        confirmButtonText: '確定',
        confirmButtonAriaLabel: '確定',
        focusConfirm: true,
      }).then(() => {
        // vm.openPopup();
      });
    },
    reset() {
      const vm = this;
      $("input[type='text']").each(function () {
        $(this).val('');
      });
      $('textarea').each(function () {
        $(this).val('');
      });
      vm.registerData = {
        Name: '',
        ContactBox: '',
        Mobile: '',
        Office: '',
        IdentificationNumber: '',
        CourseId: 0,
        // EatingHabits: '',
      };
      vm.postOptions.forEach((item, index) => {
        if (item.ColumnName === 'testCheckbox') {
          vm.postOptions[index].Info = false;
        } else {
          vm.postOptions[index].Info = '';
        }
      });
    },
    getDetail(id) {
      const vm = this;
      vm.isLoading = true;
      Api.getCourseDetail(id).then((res) => {
        vm.isLoading = false;
        if (res.status === 200) {
          vm.trainingDetail = res.data.Data;
          vm.registerData.CourseId = vm.trainingDetail.Id;
          // if (vm.trainingDetail.PreCourse.length !== 0) {
          //   vm.isEmpty = false;
          // }
          vm.setLogic();
        } else if (res === '連接錯誤631') {
          vm.error = true;
        }
      });
    },
    submit() {
      const vm = this;
      // eslint-disable-next-line no-unused-vars
      vm.$refs.form.validate().then((res) => {
        if (vm.registerData.PlanId !== '-1') {
          // vm.openPopup();
          vm.isLoading = true;
          if (
            vm.tmpRegisterData.Birthday.indexOf('-') !== -1
            || vm.tmpRegisterData.Birthday.indexOf('.') !== -1
          ) {
            vm.tmpRegisterData.Birthday = vm
              .$moment(vm.tmpRegisterData.Birthday)
              .format('YYYY/MM/DD');
          }
          vm.registerData.Birthday = vm.tmpRegisterData.Birthday;
          // 將民國年轉回西元年 暫時拿掉
          // vm.registerData.Birthday = vm
          //   .$moment(vm.tmpRegisterData.Birthday)
          //   .add(1911, 'years')
          //   .format('YYYY/MM/DD');
          // if (vm.$moment(vm.registerData.Birthday).format('YYYY') > 3000) {
          //   vm.registerData.Birthday = vm
          //     .$moment(vm.registerData.Birthday)
          //     .subtract(1900, 'years')
          //     .format('YYYY/MM/DD');
          // }
          // console.log(vm.registerData.Birthday);
          // console.log(vm.registerData.Birthday);
          vm.$set(vm.registerData, 'CourseOption', vm.postOptions);
          // vm.$set(vm.registerData, 'PersonnalAgreement', true);
          vm.$set(vm.registerData, 'status', 1);
          // vm.postRegisterData = vm.setBase64(JSON.stringify(vm.registerData));
          // eslint-disable-next-line no-buffer-constructor
          vm.postRegisterData = new Buffer( // 轉成 Base64
            JSON.stringify(vm.registerData),
          ).toString('base64');
          vm.postRegisterData = `"${vm.postRegisterData}"`;
          Api.postRegister(vm.postRegisterData).then((data) => {
            vm.isLoading = false;
            // console.log(data);
            if (data.status === 200) {
              const tmpHtml = `<h2 class="training-h2 text-flex">
            報名完成
          </h2>
          <p class="sw-text">您已完成報名作業，本會將進行後續報名資個審核，資格審核過後，您所登記的</p>
          <div class="mail">“<span>${vm.registerData.ContactBox}</span>”</div>
          <p class="sw-text">將收到報名成功通知。</p>
          </div>`;
              vm.$swal({
                html: tmpHtml,
                confirmButtonColor: '#4dba95',
                confirmButtonText: '確定',
                confirmButtonAriaLabel: '確定',
                focusConfirm: true,
              }).then(() => {
                // vm.$router.push('/Course/Index');
                window.location.href = '/Course/Index';
              });
            } else if (data === '連接錯誤645') {
              const tmpError = `<h2 class="training-h2 text-flex" style="color:red;">
            已報名過此活動。
          </h2>`;
              vm.$swal({
                icon: 'warning',
                html: tmpError,
                // text: '您已報名過此活動。',
                confirmButtonColor: '#4dba95',
                confirmButtonText: '確定',
                confirmButtonAriaLabel: '確定',
                focusConfirm: true,
              }).then(() => {
                // vm.$router.push('/Course/Index');
                window.location.href = '/Course/ParticipantSearch';
              });
            } else {
              vm.$swal({
                icon: 'warning',
                text: '網路錯誤，請稍後再試。',
                confirmButtonColor: '#4dba95',
                confirmButtonText: '確定',
                confirmButtonAriaLabel: '確定',
                focusConfirm: true,
              });
            }
          });
        }
        // else {
        //   vm.$swal({
        //     icon: 'warning',
        //     text: '請再次確認填寫內容',
        //     confirmButtonColor: '#4dba95',
        //     confirmButtonText: '確定',
        //     confirmButtonAriaLabel: '確定',
        //     focusConfirm: true,
        //   });
        // }
      });
    },
    // 信箱驗證
    IsEmail(email) {
      // eslint-disable-next-line no-useless-escape
      const regex = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
      if (!regex.test(email)) {
        return false;
      }
      return true;
    },
    // 身分證驗證
    checkID(id) {
      const tab = 'ABCDEFGHJKLMNPQRSTUVXYWZIO';
      // eslint-disable-next-line no-array-constructor
      const A1 = new Array(
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        3,
        3,
        3,
        3,
        3,
        3,
      );
      // eslint-disable-next-line no-array-constructor
      const A2 = new Array(
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        0,
        1,
        2,
        3,
        4,
        5,
      );
      // eslint-disable-next-line no-array-constructor
      const Mx = new Array(9, 8, 7, 6, 5, 4, 3, 2, 1, 1);
      let v;
      if (id.length !== 10) return false;
      const i = tab.indexOf(id.charAt(0));
      if (i === -1) return false;
      let sum = A1[i] + A2[i] * 9;

      for (let k = 1; k < 10; k += 1) {
        v = parseInt(id.charAt(k), 10);
        if (Number.isNaN(v)) return false;
        sum += v * Mx[k];
      }
      if (sum % 10 !== 0) return false;
      return true;
    },
    getColumns(id) {
      const vm = this;
      Api.getCourseDisplayColumns(id).then((res) => {
        if (res.status === 200) {
          vm.options = res.data.Data;
          vm.setOptions();
        }
      });
    },
    setOptions() {
      const vm = this;
      const keyMap = { Id: 'OptionId' };
      vm.options.forEach((item) => {
        const tmpArray = Object.keys(item).reduce((newData, key) => {
          const newKey = keyMap[key] || key;
          newData[newKey] = item[key];
          return newData;
        }, {});
        vm.postOptions.push(tmpArray);
      });
      vm.setOptionDefault();
    },
    setOptionDefault() {
      const vm = this;
      vm.postOptions.forEach((item, index) => {
        if (item.Type === 3) {
          vm.$set(vm.postOptions[index], 'Info', false);
        } else {
          vm.$set(vm.postOptions[index], 'Info', '');
        }
      });
    },
    createCodelogin() {
      const vm = this;
      vm.code = '';
      const codeLength = 6; // 驗證碼的長度
      // const checkCode = document.getElementById('checkCode');
      const codeChars = [
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        'a',
        'b',
        'c',
        'd',
        'e',
        'f',
        'g',
        'h',
        'i',
        'j',
        'k',
        'm',
        'n',
        'p',
        'q',
        'r',
        's',
        't',
        'u',
        'v',
        'w',
        'x',
        'y',
        'z',
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G',
        'H',
        'I',
        'J',
        'K',
        'M',
        'N',
        'P',
        'Q',
        'R',
        'S',
        'T',
        'U',
        'V',
        'W',
        'X',
        'Y',
        'Z',
      ]; // 所有候选组成验证码的字符，当然也可以用中文的
      for (let i = 0; i < codeLength; i += 1) {
        const charNum = Math.floor(Math.random() * 52);
        vm.code += codeChars[charNum];
      }
      // if (checkCode) {
      //   // checkCode.className = 'code';
      //   // checkCode.innerHTML = code;
      //   vm.checkCode = vm.code;
      // }
    },
    // 將年份設定為民國年
    setDay() {
      let dateNative = new Date();

      // 補0函式
      const padLeft = function (str, len) {
        if (str.length >= len) {
          return str;
        }
        return padLeft(`0${str}`, len);
      };

      const twSettings = {
        closeText: '關閉',
        prevText: '上個月',
        nextText: '下個月',
        currentText: '今天',
        changeYear: true, // 手動修改年
        changeMonth: true, // 手動修改月
        yearRange: `1912:${dateNative.getFullYear()}`,
        monthNames: [
          '一月',
          '二月',
          '三月',
          '四月',
          '五月',
          '六月',
          '七月',
          '八月',
          '九月',
          '十月',
          '十一月',
          '十二月',
        ],
        monthNamesShort: [
          '一月',
          '二月',
          '三月',
          '四月',
          '五月',
          '六月',
          '七月',
          '八月',
          '九月',
          '十月',
          '十一月',
          '十二月',
        ],
        dayNames: [
          '星期日',
          '星期一',
          '星期二',
          '星期三',
          '星期四',
          '星期五',
          '星期六',
        ],
        dayNamesShort: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
        dayNamesMin: ['日', '一', '二', '三', '四', '五', '六'],
        weekHeader: '周',
        dateFormat: 'yy/mm/dd',
        splitMark: '/', // 分割年月日的標誌
        firstDay: 1,
        isRTL: false,
        showMonthAfterYear: false,
        yearSuffix: '',
        yearPadZero: false,
        beforeShow() {
          setTimeout(() => {
            $('.ui-datepicker').css('z-index', 1000);
          }, 0);
        },
        // ,defaultLastYear: false
        /*
            當沒有設defaultDate時，先用yearRange做defaultDate
            此時defaultLastYear設定預設為最後一年or第一年
        */
      };

      const funcColle = function () {
        this.onSelect = {
          basic(dateText, inst) {
            /*
                var yearNative = inst.selectedYear < 1911 ? inst.selectedYear + 1911 : inst.selectedYear;
                */
            dateNative = new Date(
              inst.selectedYear,
              inst.selectedMonth,
              inst.selectedDay,
            );

            // 年分小於100會被補成19**, 要做例外處理
            let yearTW;
            if (twSettings.yearPadZero) {
              if (inst.selectedYear > 1911) {
                yearTW = padLeft((inst.selectedYear - 1911).toString(), 3);
              } else {
                yearTW = padLeft(inst.selectedYear.toString(), 3);
              }
            } else if (inst.selectedYear > 1911) {
              yearTW = inst.selectedYear - 1911;
            } else {
              yearTW = inst.selectedYear;
            }
            const monthTW = padLeft((inst.selectedMonth + 1).toString(), 2);
            const dayTW = padLeft(inst.selectedDay, 2);

            return (
              yearTW
              + twSettings.splitMark
              + monthTW
              + twSettings.splitMark
              + dayTW
            );
          },
        };
      };

      // 把yearText換成民國
      const replaceYearText = function () {
        const $yearText = $('.ui-datepicker-year');

        if (twSettings.changeYear !== true) {
          $yearText.text(`民國${dateNative.getFullYear()}` - 1911);
        } else {
          // 下拉選單
          /*
            if($yearText.prev('span.datepickerTW-yearPrefix').length === 0){
                $yearText.before("民國  ");
            }
*/
          $yearText.children().each(function () {
            if (parseInt($(this).text(), 10) > 1911) {
              $(this).text(parseInt($(this).text(), 10) - 1911);
            }
          });
        }
      };

      $.fn.datepickerTW = function (options) {
        if (typeof options === 'undefined') {
          options = {};
        }

        const fn = new funcColle();
        // setting on init,
        if (typeof options === 'object') {
          // onSelect例外處理, 避免覆蓋
          if (typeof options.onSelect === 'function') {
            fn.onSelect.newFunc = options.onSelect;
          }

          options.onSelect = function (dateText, inst) {
            let outputValue = fn.onSelect.basic(dateText, inst);

            if (twSettings.yearPadZero) {
              outputValue = padLeft(outputValue, 9);
            }
            $(this).val(outputValue);

            if (typeof fn.onSelect.newFunc === 'function') {
              fn.onSelect.newFunc(outputValue, inst);
            }
          };

          // year range正規化成西元, 小於1911的數字都會被當成民國年
          if (options.yearRange) {
            const temp = options.yearRange.split(':');
            for (let i = 0; i < temp.length; i += 1) {
              // 民國前處理
              if (parseInt(temp[i], 10) < 1) {
                temp[i] = parseInt(temp[i], 10) + 1911;
              } else if (parseInt(temp[i], 10) < 1911) {
                temp[i] = parseInt(temp[i], 10) + 1911;
              } else {
                temp[i] = temp[i];
              }
            }
            options.yearRange = `${temp[0]}:${temp[1]}`;
          }

          // 預設default Date
          if (options.defaultDate) {
          } else if (options.yearRange) {
            const temp = options.yearRange.split(':');

            if (options.defaultLastYear) {
              options.defaultDate = `${temp[1] - new Date().getFullYear()}y`;
            } else {
              options.defaultDate = `${temp[0] - new Date().getFullYear()}y`;
            }
          } else if (
            $.trim($(this).val()) !== ''
            && $(this).val() !== undefined
          ) {
            const tempDate = $(this).val().split(twSettings.splitMark);
            const tempYear = tempDate[0];

            let year;
            if (parseInt(tempYear, 10) < 1911) {
              year = padLeft((parseInt(tempYear, 10) + 1911).toString(), 4);
            } else {
              year = parseInt(tempYear, 10);
            }

            options.defaultDate = `${year - new Date().getFullYear()}y`;
          }
        }

        // setting after init
        if (arguments.length > 1) {
          // 目前還沒想到正常的解法, 先用轉換成init setting obj的形式
          if (arguments[0] === 'option') {
            options = {};
            options[arguments[1]] = arguments[2];
          }
        }

        // override settings
        $.extend(twSettings, options);

        // init
        $(this).datepicker(twSettings);

        // beforeRender
        $(this).click(function () {
          const isFirstTime = $(this).val() === '';
          // year range and default date
          if ((twSettings.defaultDate || twSettings.yearRange) && isFirstTime) {
            /*              當有year range時, select初始化設成range的最末年
                已調整到上面"預設default Date"中
                if(twSettings.defaultDate){
                    $(this).datepicker('setDate', twSettings.defaultDate);
                }

                // 這段處理不好，因為「年」只改了外觀，但javascript實際值還是原本那年
                // 當有year range時, select初始化設成range的最末年
                if(twSettings.yearRange){
                    var $yearSelect = $('.ui-datepicker-year'),
                        nowYear = twSettings.defaultDate
                            ? $(this).datepicker('getDate').getFullYear()
                            : dateNative.getFullYear();

                    $yearSelect.children(':selected').removeAttr('selected');
                    if($yearSelect.children('[value=' + nowYear + ']').length > 0){
                        $yearSelect.children('[value=' + nowYear + ']').attr('selected', 'selected');
                    }else{
                        $yearSelect.children().last().attr('selected', 'selected');
                    }
                }
*/
          } else {
            const tempDate = $(this).val().split(twSettings.splitMark);

            if (tempDate.length !== 3) {
              $(this).datepicker('setDate', new Date());
            } else {
              const tempYear = tempDate[0];
              const tempMonth = tempDate[1] - 1;
              const tempDay = padLeft(tempDate[2], 2);

              let year;
              if (parseInt(tempYear, 10) < 1911) {
                year = padLeft((parseInt(tempYear, 10) + 1911).toString(), 4);
              } else {
                year = parseInt(tempYear, 10);
              }

              dateNative = new Date(year, tempMonth, tempDay);

              $(this).datepicker('setDate', dateNative);
            }
          }

          let yearTW;
          if (twSettings.yearPadZero) {
            if (dateNative.getFullYear() > 1911) {
              yearTW = padLeft((dateNative.getFullYear() - 1911).toString(), 3);
            } else {
              yearTW = padLeft(dateNative.getFullYear().toString(), 3);
            }
          } else if (dateNative.getFullYear() > 1911) {
            yearTW = dateNative.getFullYear() - 1911;
          } else {
            yearTW = dateNative.getFullYear();
          }
          const monthTW = padLeft((dateNative.getMonth() + 1).toString(), 2);
          const dayTW = padLeft(dateNative.getDate().toString(), 2);

          $(this).val(
            yearTW
              + twSettings.splitMark
              + monthTW
              + twSettings.splitMark
              + dayTW,
          );

          replaceYearText();

          if (isFirstTime) {
            $(this).val('');
          }
        });

        // afterRender
        $(this).focus(() => {
          replaceYearText();
        });

        return this;
      };
    },
    setBase64(str) {
      const encode = encodeURI(str);
      const base64 = btoa(encode);
      return base64;
    },
    setLogic() {
      const vm = this;
      const now = new Date();
      const start = new Date(vm.trainingDetail.ParticipantStartOn);
      const end = new Date(vm.trainingDetail.ParticipantEndOn);
      const limit = vm.trainingDetail.Limit;
      const nowCount = vm.trainingDetail.ParticipantCount;
      if (now < start) {
        vm.isStart = true;
      } else if (now > end) {
        vm.isOver = true;
      } else if (nowCount >= limit) {
        vm.isLimit = true;
      }
    },
  },
  created() {
    const vm = this;
    const id = window.location.href.split('/');
    vm.CourseId = Number(id[5]);
    vm.setDay();
    vm.createCodelogin();
    vm.getDetail(vm.CourseId);
    vm.getColumns(vm.CourseId);
    extend('IdCheck', {
      validate(value) {
        const tab = 'ABCDEFGHJKLMNPQRSTUVXYWZIO';
        // eslint-disable-next-line no-array-constructor
        const A1 = new Array(
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          2,
          2,
          2,
          2,
          2,
          2,
          2,
          2,
          2,
          2,
          3,
          3,
          3,
          3,
          3,
          3,
        );
        // eslint-disable-next-line no-array-constructor
        const A2 = new Array(
          0,
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9,
          0,
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9,
          0,
          1,
          2,
          3,
          4,
          5,
        );
        // eslint-disable-next-line no-array-constructor
        const Mx = new Array(9, 8, 7, 6, 5, 4, 3, 2, 1, 1);
        let v;
        if (value.length !== 10) return false;
        const i = tab.indexOf(value.charAt(0));
        if (i === -1) return false;
        let sum = A1[i] + A2[i] * 9;

        for (let k = 1; k < 10; k += 1) {
          v = parseInt(value.charAt(k), 10);
          if (Number.isNaN(v)) return false;
          sum += v * Mx[k];
        }
        if (sum % 10 !== 0) return false;
        return true;
      },
      message: '身分證字號格式錯誤',
    });
    localize('zh-TW', tw);
    // 載入所有規則
    Object.keys(rules).forEach((rule) => {
      extend(rule, rules[rule]);
    });
    const ua = window.navigator.userAgent;
    const oldIe = ua.indexOf('MSIE ');
    const newIe = ua.indexOf('Trident/');
    if (oldIe > -1 || newIe > -1) {
      vm.ms_ie = true;
    }
  },
  mounted() {
    const vm = this;
    // console.log(vm.$refs.form.validate());
    $('[name ="Birthday"]').datepickerTW({
      dateFormat: 'yy/mm/dd',
      onSelect(date) {
        vm.tmpRegisterData.Birthday = date; // update date model
        $('[name ="Birthday"]').focus();
      },
    });
  },
  filters: {
    dayFormat(data) {
      return data.split('.')[2].split(' ')[0];
    },
    monthFormat(data) {
      let tmpMonth = data.split('.');
      switch (tmpMonth[1]) {
        case '01':
          tmpMonth = 'JAN';
          break;
        case '02':
          tmpMonth = 'FEB';
          break;
        case '03':
          tmpMonth = 'MAR';
          break;
        case '04':
          tmpMonth = 'APR';
          break;
        case '05':
          tmpMonth = 'MAY';
          break;
        case '06':
          tmpMonth = 'JUN';
          break;
        case '07':
          tmpMonth = 'JUL';
          break;
        case '08':
          tmpMonth = 'AUG';
          break;
        case '09':
          tmpMonth = 'SEP';
          break;
        case '10':
          tmpMonth = 'OCT';
          break;
        case '11':
          tmpMonth = 'NOV';
          break;
        case '12':
          tmpMonth = 'DEC';
          break;

        default:
          break;
      }
      return tmpMonth;
    },
  },
  watch: {
    'tmpRegisterData.Birthday': function (val) {
      $('[name ="Birthday"]').val(val);
    },
  },
};
</script>

<style lang="scss" scoped>
.other-bg {
  min-height: 100vh;
  background-size: cover;
  background-repeat: no-repeat;
}

.training-content {
  padding: 0 4rem 300px 4rem;
  @media (max-width: 1024px) {
    padding: 0 0 300px 0;
  }
}

.registration-title {
  h2 {
    display: inline-block;
  }
  span {
    font-size: 0.75rem;
    color: #ff3838;
  }
}

.training-h3 {
  font-size: 1.5rem;
  text-align-last: left;
}

.table-line {
  height: 1px;
  background-color: #edf1f1;
  width: 100%;
}

#AC,
#AU {
  color: transparent;
}

.training-detail-container {
  padding: 0.6rem 5rem;
  @media (max-width: 1024px) {
    padding: 0.6rem 0;
  }
}

.training-detail-content {
  background-color: #fff;
  border-radius: 1rem;
  padding: 4.5rem 5rem 4.5rem 9rem;
  box-shadow: 0 0 3px 3px rgba(227, 232, 232, 0.5);
  @media (max-width: 1366px) {
    padding: 1.5rem;
  }

  &.error {
    line-height: 1.5;
    font-size: 1.5rem;
  }

  .list {
    display: flex;
    align-items: flex-start;
    font-size: 1.1rem;
    color: #3e3e3f;
    letter-spacing: 1.5px;
    margin-bottom: 1rem;
    flex-direction: column;
    @media (max-width: 420px) {
      flex-direction: column;
      margin-bottom: 2rem;
      align-items: flex-start;
    }

    .input-block {
      display: flex;
      align-items: center;
      width: 100%;
      @media (max-width: 420px) {
        flex-direction: column;
        margin-bottom: 2rem;
        align-items: flex-start;
      }

      .inputbox {
        .content {
          width: 150px;
          @media (max-width: 420px) {
            margin-bottom: 15px;
          }
        }
      }
    }

    &.list-textarea {
      align-items: flex-start;
    }
    .title {
      min-width: 120px;
      display: inline-block;
      text-align: right;
      margin-right: 30px;
      span {
        color: #ff3838;
      }
      @media (max-width: 420px) {
        text-align: left;
        margin-bottom: 10px;
      }
    }
    .content {
      width: 100%;
      display: inline-block;
      &.checkbox {
        width: unset;
      }
    }
    input.content {
      padding: 0.75rem 0.75rem 0.5rem 0.75rem;
      border: unset;
      font-size: 1.1rem;
      border-bottom: 1px solid #535353;
      &.is-invalid {
        border-bottom: 1px solid #ff3838;
      }
    }
    select.content {
      width: 50%;
      padding: 0.5rem;
      border: unset;
      font-size: 1.1rem;
      border-bottom: 1px solid #535353;
    }
    textarea {
      height: 10rem;
      font-size: 1.1rem;
      padding: 0.5rem;
    }

    .text-danger {
      display: block;
      width: 100%;
      text-align: right;
      color: #ff3838;
      padding-top: 0.2rem;
    }
  }
  .btn-box {
    display: flex;
    justify-content: flex-end;
    padding-top: 5.5rem;
    @media (max-width: 767px) {
      flex-direction: column;
      align-items: center;
    }

    a:not(:last-child) {
      margin-right: 1rem;

      @media (max-width: 767px) {
        margin-right: 0;
        margin-bottom: 1.5rem;
      }
    }
  }
  .btn {
    display: block;
    color: #fff;
    border-radius: 5rem;
    padding: 0.5rem 0;
    width: 120px;
    font-size: 1.5rem;
    letter-spacing: 5px;
    text-decoration: none;
    text-align: center;

    &.light-green {
      background-color: #4dba95;
    }

    &.reset {
      background-color: #bfbfbf;
    }

    &.cancel {
      background-color: #d2d2d2;
    }
  }
}
.code {
  font-size: 1.2rem;
  cursor: pointer;
  border: 1px solid #a7a8aa;
  display: inline-block;
  padding: 5px 7px;
  margin: 0 10px;
  letter-spacing: 2px;
}

.codeBtn {
  font-weight: bold;
  display: inline-block;
  background-color: #bfbfbf;
  color: #fff;
  border-radius: 5rem;
  padding: 0.5rem 0.3rem;
  font-size: 1.2rem;
  letter-spacing: 1px;
  text-decoration: none;
  text-align: center;
  border: none;
  cursor: pointer;

  &:focus {
    outline: 3px dashed #5da3ab;
  }
}
</style>

<style lang="scss">
.training-h2 {
  background: linear-gradient(to bottom, #a0c8c0 0, #5aa3a8 100%);
  color: transparent;
  background-clip: text;
  -webkit-background-clip: text;
  font-size: 3rem;
  font-weight: bold;
  letter-spacing: 10px;
  margin-bottom: 1.5rem;

  @media (max-width: 360px) {
    letter-spacing: 1.5px;
  }
}

.training-h2-ie {
  color: #5aa3a8;
  font-size: 3rem;
  font-weight: bold;
  letter-spacing: 10px;
  margin-bottom: 1.5rem;

  @media (max-width: 360px) {
    letter-spacing: 1.5px;
  }
}

.pop-check {
  text-align: center;
  font-size: 1.5rem;
  color: #f98d28;
  padding: 10px 0;
  input[type="checkbox"] {
    border: 2px solid #f98d28;
    width: 16px;
    height: 16px;
  }
}

// sweetalert 客製
.swal2-content {
  padding: 0 1rem;

  p {
    text-align-last: left;
    font-size: 1.1rem;
  }

  .sw-text {
    text-align-last: center;
    font-size: 1.1rem;
  }
  .mail {
    font-size: 1.5rem;
    padding: 1rem 0;
    @media (max-width: 420px) {
      font-size: 1.1rem;
    }
    span {
      color: #eb4141;
    }
  }
}

.swal2-styled.swal2-confirm,
.swal2-styled.swal2-cancel {
  font-size: 1.5rem;
  border-radius: 5rem;
  font-weight: bold;
  padding: 10px 55px;
}

.swal2-styled:focus {
  outline: 3px dashed #5da3ab;
}
</style>
